<!-- Company Switcher - nur anzeigen wenn Multi-Company User -->
<div
  class="company-switcher"
  *ngIf="hasMultipleCompanies"
  [class.compact]="isCompact && !isMobileMode"
  [class.mobile-mode]="isMobileMode"
>
  <!-- Trigger Button -->
  <button
    type="button"
    class="switcher-trigger"
    (click)="toggleDropdown()"
    [disabled]="isLoading"
    [title]="activeCompany?.CompanyName || ''"
  >
    <!-- Company Icon -->
    <div class="company-icon-small">
      <img
        *ngIf="activeCompany?.CompanyIcon"
        [src]="activeCompany?.CompanyIcon"
        [alt]="activeCompany?.CompanyName"
        class="company-logo-small"
      />
      <div *ngIf="!activeCompany?.CompanyIcon" class="company-icon-placeholder-small">
        <i class="fa-light fa-building"></i>
      </div>
    </div>

    <!-- Company Name (nicht im Compact Mode) -->
    <span class="company-name-text" *ngIf="!isCompact || isMobileMode">
      {{ activeCompany?.CompanyName }}
    </span>

    <!-- Dropdown Arrow -->
    <i
      class="fa-light dropdown-arrow"
      [class.fa-chevron-down]="!isDropdownOpen"
      [class.fa-chevron-up]="isDropdownOpen"
      *ngIf="!isCompact || isMobileMode"
    ></i>

    <!-- Loading Indicator -->
    <i class="fa-light fa-spinner fa-spin loading-icon" *ngIf="isLoading"></i>
  </button>

  <!-- Dropdown Menu -->
  <div
    class="switcher-dropdown"
    *ngIf="isDropdownOpen && !isLoading"
    (click)="stopPropagation($event)"
  >
    <!-- Header -->
    <div class="dropdown-header">
      <i class="fa-light fa-building"></i>
      <span>{{ 'COMPANY_SWITCHER_TITLE' | translate }}</span>
    </div>

    <!-- Company List -->
    <div class="company-list">
      <div
        *ngFor="let company of availableCompanies"
        class="company-item"
        [class.active]="isActiveCompany(company)"
        [class.default]="company.IsDefault"
        (click)="switchToCompany(company)"
      >
        <!-- Company Icon -->
        <div class="company-icon">
          <img
            *ngIf="company.CompanyIcon"
            [src]="company.CompanyIcon"
            [alt]="company.CompanyName"
            class="company-logo"
          />
          <div *ngIf="!company.CompanyIcon" class="company-icon-placeholder">
            <i class="fa-light fa-building"></i>
          </div>
        </div>

        <!-- Company Info -->
        <div class="company-info">
          <span class="company-name">{{ company.CompanyName }}</span>
          <span class="company-role">
            <i class="fa-light" [ngClass]="getRoleIcon(company.Role)"></i>
            {{ getRoleLabel(company.Role) }}
          </span>
        </div>

        <!-- Indicators -->
        <div class="company-indicators">
          <!-- Active Check -->
          <i
            class="fa-solid fa-circle-check active-indicator"
            *ngIf="isActiveCompany(company)"
          ></i>

          <!-- Default Badge -->
          <span class="default-badge" *ngIf="company.IsDefault">
            <i class="fa-light fa-star"></i>
          </span>
        </div>
      </div>
    </div>

    <!-- Set as Default Option -->
    <div class="dropdown-footer" *ngIf="!isActiveCompany(availableCompanies[0])">
      <label class="set-default-option" (click)="stopPropagation($event)">
        <input
          type="checkbox"
          [(ngModel)]="setAsDefault"
          class="default-checkbox"
        />
        <span>{{ 'COMPANY_SWITCHER_SET_DEFAULT' | translate }}</span>
      </label>
    </div>
  </div>

  <!-- Backdrop zum Schließen -->
  <div
    class="dropdown-backdrop"
    *ngIf="isDropdownOpen"
    (click)="closeDropdown()"
  ></div>
</div>
